import {
  PageBlueprint,
  createFrontendPlugin,
  createRouteRef,
} from '@backstage/frontend-plugin-api';

export const githubExplorerRouteRef = createRouteRef();

const githubExplorerPage = PageBlueprint.make({
  params: {
    path: '/github',
    noHeader: true,
    routeRef: githubExplorerRouteRef,
    loader: () =>
      import('./components/GitHubPageWrapper').then(m => <m.GitHubPage />),
  },
});

export default createFrontendPlugin({
  pluginId: 'github-explorer',
  extensions: [githubExplorerPage],
});
